module.exports = __webpack_public_path__ + "img/why-us.18646ed3.svg";